import { EqualiserBar } from './../../../../entities/setup/model';
import { Component, Inject, OnInit } from '@angular/core';
import { ShoeSize, ComponentGrouser, Make } from '../../../../../app/entities';
import { BushTurnedCalcParams, ComponentChangeViewModel, ComponentDetails } from '../../../../../app/modules/manage-equipment/models/manage-equipment.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionService } from '../../../action/action.service.service';
import { ReplacementCompartmentViewModel } from '../../../action/action-models';
import { ManageEquipmentService } from '../../manage-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { SetupUndercarriageService } from '../../../setup-undercarriage';
import { componentTypes } from '../../../../shared/enums/allEnums';


@Component({
  selector: 'app-change-component',
  templateUrl: './change-component.component.html',
  styleUrls: ['./change-component.component.scss']
})
export class ChangeComponentComponent implements OnInit {
  _availableShoeSizes: ShoeSize[] = [];
  _availableCleanerholes: ShoeSize[] = [];
  _availableGrousers: ComponentGrouser[] = [{ Id: 0, Title: 'Unknown' }, { Id: 1, Title: 'Single Grouser' }, { Id: 2, Title: 'Double Grouser' }, { Id: 3, Title: 'Triple Grouser' }, { Id: 4, Title: 'Self Cleaning' }];
  _shoeSize: number = 0;
  _grouserId: number = 0;
  _cleanerHolesId: number = 0;
  _componentReplaceOptions: ReplacementCompartmentViewModel[];
  _newComponentId: number;
  _currentComponent: string;
  //_isShoe: boolean = false;
  _saving: boolean = false;
  _componentType: number;
  _componentTypes = componentTypes;
  _Makes: Make[] = [];
  _make: number;
  _budgetLife: number;
  _masterLink: number;
  _jobNumber: string;
  _bushTurnedBudgetPer: number;
  _assetNumber: string;
  _bushTurnedHours:number;
  _cmu: number;
  _wornPercentage:number;
  screenId: number;
  equipmentId: number;
  isEqualiserBar: boolean = false;
  currentEqBar: number = 0;
  availableEqBar: string;
  selectedEqBar: string = null;
  systemType: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ChangeComponentComponent>,
    private _actionService: ActionService,
    private _equipment: ManageEquipmentService,
    private _notification: NotificationsService,
    private _setupService: SetupUndercarriageService,
  ) { }

  ngOnInit() {
    console.log("this.data.: ", this.data);
    this._componentType = this.data.comparttype_auto;
    this.systemType = this.data.SystemType;
    //if (this.data.comparttype_auto == this._componentTypes.Shoe)
    //  this._isShoe = true;
    this.isEqualiserBar = this.data.isEqualiserBar;
    if(this.systemType != 'EqualiserBar')
      this.getReplacementComponentOptions();
    else {
      // this._currentComponent = this.data.currentEqBar == 1 ? 'ToeOut' : 'Straight';
      // this.availableEqBar = this.data.currentEqBar === 1 ? 'Straight' : 'ToeOut';
      // console.log("this.availableEqBar:", this.availableEqBar);
      //this.selectedEqBar = null;
      this.getEqAvaialableCompart();
    }
    this.getMakes();
    this._setupService.getShoeSizeList().subscribe(result => {
      this._availableShoeSizes = result;
    });
    this._setupService.getCleanerHolesList().subscribe(result => {
      this._availableCleanerholes = result;
    });
    this._shoeSize = this.data.shoeSizeId;
    this._grouserId = this.data.shoeGrouserId;
    this._cleanerHolesId = this.data.cleanerHolesId;
    this._make = this.data.make;
    this._budgetLife = this.data.budgetLife;
    this._masterLink = this.data.masterLink;
    this._jobNumber = this.data.jobNumber;
    this._bushTurnedBudgetPer = this.data.bushTurnedBudgetPer;
    this._assetNumber = this.data.assetNumber;
    this._bushTurnedHours = this.data.bushTurnedHour;
    this._cmu = this.data.cmu;
    this._wornPercentage = this.data.wornPercentage;
    this.screenId = this.data.screenId;
    this.equipmentId = this.data.equipmentId;
  }

  getEqAvaialableCompart(){
    this._setupService.getCompartsByCompartType(this.systemType).subscribe(x => {
      this._currentComponent = x.find(o => o.Id === this.data.compartid_auto).CompartTitle;
      
      const replacementComponents: ReplacementCompartmentViewModel[] = x.map(c => ({
    Id: c.Id,
    Name: c.CompartTitle,      
    CompartType: c.CompartType.Id,
    isChild: false,
    isParent: false,
    BudgetLife: 0,
    BudgetDistance: 0
  }));

  this._componentReplaceOptions = replacementComponents.filter(f => f.Id != this.data.compartid_auto);
  console.log('this._componentReplaceOptions', this._componentReplaceOptions);
    })
  }


  onSave(){
    this.SaveUpdate();
  }

  // saveUpdateEqBar(){
  //   var _ComponentChangeViewModel = new ComponentChangeViewModel();
  //   equalierBar.EquipmentId = this.equipmentId;
  //   equalierBar.BudgetLife = this._budgetLife;
  //   equalierBar.ToeOut = this.selectedEqBar == 'ToeOut' ? 1 : this.selectedEqBar == 'Straight' ? 2 : null;
  //   equalierBar.BrandId = this._make;
  //   this._saving = true;
  //   this._equipment.changeEqualiserBar(equalierBar)
  //     .subscribe({
  //       next: (succeeded) => {
  //         this._saving = false;
  //         if (succeeded) {
  //           this._notification.success('Component Changed', 'This component has been successfully changed.');
  //           this.dialogRef.close(true);
  //         } else {
  //           this.dialogRef.close(false);
  //           this._notification.error('Error', 'Unable to change this component. Please contact TrackTreads support.');
  //         }
  //       },
  //       error: (error) => {
  //         this._saving = false;
  //         this._notification.error('Error', 'An unexpected error occurred. Please try again later.');
  //         console.error(error);
  //       }
  //   });
  // }

  SaveUpdate() {
    console.log("_newComponentId:", this._newComponentId)
    if (this._newComponentId == undefined)
      this._newComponentId = 0;
    if (this._shoeSize == undefined)
      this._shoeSize = 0;
    if (this._grouserId == undefined)
      this._grouserId = 0;
    if (this._cleanerHolesId == undefined)
      this._cleanerHolesId = 0;
    var _ComponentChangeViewModel = new ComponentChangeViewModel();
    _ComponentChangeViewModel.EqUnitId = this.data.eQunitId;
    _ComponentChangeViewModel.OldComponentId = this.data.compartid_auto;
    _ComponentChangeViewModel.NewComponentId = this._newComponentId;
    _ComponentChangeViewModel.CompartTypeId = this.data.comparttype_auto;
    _ComponentChangeViewModel.ShoeSizeId = this._shoeSize;
    _ComponentChangeViewModel.ShoeGrouserId = this._grouserId;
    _ComponentChangeViewModel.CleanerHolesId = this._cleanerHolesId;
    _ComponentChangeViewModel.MakeId = this._make;
    _ComponentChangeViewModel.BudgetLife = this._budgetLife;
    _ComponentChangeViewModel.MLink = this._masterLink == undefined ? -1 : this._masterLink ;
    _ComponentChangeViewModel.JobNumber = this._jobNumber;
    _ComponentChangeViewModel.BushTurnedPer = this._bushTurnedBudgetPer == undefined ? -1 : this._bushTurnedBudgetPer;
    _ComponentChangeViewModel.AssetNumber = this._assetNumber;
    _ComponentChangeViewModel.BushTurnedHour = this._bushTurnedHours;
    _ComponentChangeViewModel.ScreenId = this.screenId;
    this._saving = true;
    if(this.systemType != 'EqualiserBar'){
      this._equipment.changeSystemComponent(_ComponentChangeViewModel)
      .subscribe({
        next: (succeeded) => {
          this._saving = false;
          if (succeeded) {
            this._notification.success('Component Changed', 'This component has been successfully changed.');
            this.dialogRef.close(true);
          } else {
            this.dialogRef.close(false);
            this._notification.error('Error', 'Unable to change this component. Please contact TrackTreads support.');
          }
        },
        error: (error) => {
          this._saving = false;
          this._notification.error('Error', 'An unexpected error occurred. Please try again later.');
          console.error(error);
        }
      });
    } else {
      this._equipment.changeEqualiserBar(_ComponentChangeViewModel)
      .subscribe({
        next: (succeeded) => {
          this._saving = false;
          if (succeeded) {
            this._notification.success('Component Changed', 'This component has been successfully changed.');
            this.dialogRef.close(true);
          } else {
            this.dialogRef.close(false);
            this._notification.error('Error', 'Unable to change this component. Please contact TrackTreads support.');
          }
        },
        error: (error) => {
          this._saving = false;
          this._notification.error('Error', 'An unexpected error occurred. Please try again later.');
          console.error(error);
        }
    });
    }
  }

  getReplacementComponentOptions() {
    //console.log("this._currentComponent: ", this._currentComponent, this.data.compartid_auto);
    this._actionService.getReplacementComponentOptions(this.data.eQunitId).subscribe(c => {
      this._currentComponent = c.find(o => o.Id === this.data.compartid_auto).Name;
      this._componentReplaceOptions = c.filter(f => f.Id != this.data.compartid_auto && !f.isChild && !f.isParent);
      console.log("this._componentReplaceOption.length:", this._componentReplaceOptions, this._componentReplaceOptions.length);
      if (this._componentReplaceOptions.length < 1) {
        var _ReplacementCompartmentViewModel = new ReplacementCompartmentViewModel();
        _ReplacementCompartmentViewModel.Id = 0;
        _ReplacementCompartmentViewModel.Name = "No Replacement Component Available";
        this._componentReplaceOptions.push(_ReplacementCompartmentViewModel);
        this._newComponentId = this._componentReplaceOptions[0].Id;
      }
    });
  }

  getMakes() {
    this._setupService.getComponentMakeList().subscribe(result => {
      this._Makes = result;
    }, error => { }, () => {  });
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

onChange() {
  const params = new BushTurnedCalcParams();
  params.PercentWorn = this._wornPercentage;
  params.BudgetLife = this._budgetLife;
  params.BushTurnedPercent = this._bushTurnedBudgetPer;
  params.CMU = this._cmu;

  this._equipment.calcBushTurned(params).subscribe(result => {
    this._bushTurnedHours = result;
  }, error => {
    console.error('Calculation error:', error);
  });
}

}
